import Component from './InDmDate.vue'
export default Component
export * from './types'
